<div class="debug"><pre>{{ model | json }}</pre></div>
